import { render } from "./InstructorSessionInfo.vue?vue&type=template&id=5b626a45&scoped=true"
import script from "./InstructorSessionInfo.vue?vue&type=script&lang=js"
export * from "./InstructorSessionInfo.vue?vue&type=script&lang=js"

import "./InstructorSessionInfo.vue?vue&type=style&index=0&id=5b626a45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b626a45"]])

export default __exports__